export const PARKING_COUNTDOWN_SECONDS = 60;

export function parkingSecondsRemaining(sentAt: string | null | undefined, nowMs = Date.now()): number {
  const startedAt = sentAt ? Date.parse(sentAt) : Number.NaN;
  if (!Number.isFinite(startedAt)) return PARKING_COUNTDOWN_SECONDS;
  return Math.max(0, Math.min(PARKING_COUNTDOWN_SECONDS, Math.ceil(
    (startedAt + PARKING_COUNTDOWN_SECONDS * 1_000 - nowMs) / 1_000
  )));
}

export function parkingCountdownProgress(secondsRemaining: number): number {
  const bounded = Math.max(0, Math.min(PARKING_COUNTDOWN_SECONDS, secondsRemaining));
  return (PARKING_COUNTDOWN_SECONDS - bounded) / PARKING_COUNTDOWN_SECONDS;
}
